var email_validation_id, global_result;
var evs_flag = $('#evs_flag').val();
var dja_api_url = $("#dja_api_url").val();
var dja_api_token = $("#dja_api_token").val();
var language = $("#language").val();

// Google captcha start
var google_captcha_key = $('#google_captcha_key').val();
if (language === 'EN') {
    var emailemptyValidate = "Please fill email address";
    var emailValidate = "Please provide a valid email address";
    var firsttimeEmailsubmit = "An email will be sent to you shortly with a unique link that you will need to click in order to begin the email validation process. If your email address is validated, the link will bring you to the registration form which you will need to complete and submit, in order to play the game/enter the sweepstakes. The link will expire 10 minutes after you receive the email.";
    var usernotfound = 'The email address you submitted cannot be validated. Please try again with another email address.';
    var alreadyPlayedMain = `<div class="results-title">Sorry</div>
       <div class="loss-msg-1">IT LOOKS LIKE YOU’VE ALREADY PLAYED THE GAME TODAY. </div>
        <div class="loss-msg-2">COME BACK EVERY DAY THROUGH MAY 5, 2023 FOR ANOTHER CHANCE TO WIN!</div>`;
} else {
    var emailemptyValidate = "Please fill email address";
    var emailValidate = "Please provide a valid email address";
    var firsttimeEmailsubmit = "En breve recibirá un mensaje de correo electrónico con un vínculo exclusivo en el que deberá hacer clic para comenzar el proceso de validación de la dirección de correo electrónico. De validar su dirección de correo electrónico, el vínculo le llevará al formulario de registro que deberá llenar y enviar para poder participar en el juego o en el sorteo. El vínculo caducará 10 minutos después de que reciba el mensaje de correo electrónico.";
    var usernotfound = 'No es posible validar la dirección de correo electrónico que envió. Haga para intentar de nuevo con otra dirección de correo electrónico.';
    var alreadyPlayedMain = `<div class="results-title">LO SENTIMOS.</div>
       <div class="loss-msg-1"> PARECE QUE USTED YA HA PARTICIPADO EN EL JUEGO DE HOY.</div>
        <div class="loss-msg-2">¡PUEDE REGRESAR TODOS LOS DÍAS HASTA EL 5 DE MAYO DE 2023PARA TENER OTRA OPORTUNIDAD DE GANAR!</div>`;
}



var onloadCallback = function () {
    grecaptcha.render('html_element_sweepstake', {
        sitekey: google_captcha_key,
    });
    grecaptcha.render('html_element', {
        sitekey: google_captcha_key,
    });
};
// Google captcha end

function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    let expires = 'expires=' + d.toUTCString();
    document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/;domain=' + location.hostname.replace(/^www\./i, "");
}

function getCookie(cname) {
    let name = cname + '=';
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return '';
}

window.APP = {
    init: function () {
        this.validateForm()
    },
    validateForm: function () {
        $.validator.addMethod("emailValidate", function (value, element) {
            return this.optional(element) || /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/i.test(value);
        }, "Please provide a valid email address");
    }
}

$(function () {
    //$('.promo-entry__form-wrap.address').hide();
    APP.init();
});

$(document).ready(function () {
    var shop_token = $("#store_id").val();
    var prmo_id = $("#promo_id").val();
    var shop_url = Shopify.shop;
    var api_domain_url = $('#endpoint_url').val();
    var emailRequiredMssg;
    var invalidEmailMssg;
    var emailRequiredMssg = "Email address required";
    var invalidEmailMssg = "Invalid email address";

    // Get URL Token start
    var getUrlParameter = function getUrlParameter(sParam) {
        var sPageURL = window.location.search.substring(1),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;
        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');
            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
            }
        }
        return false;
    };

    if (evs_flag == 'true') {
        var accessToken = getUrlParameter('token');
        // Get URL Token end
        // Onload Ajax call start

        if (accessToken) {
            var onloaddata = { promo_identifier: prmo_id, shop_url: shop_url };
            $('#popup-enabled-overlay').show();
            $('.spin-btn-overlay').css('pointer-events', 'none');
            $.ajax({
                type: 'GET',
                url: api_domain_url + '/api/verify-mail/' + accessToken,
                data: onloaddata,
                dataType: 'json',
                headers: { Authorization: 'Bearer ' + shop_token, Accept: 'application/json' },
                success: function (result) {
                    console.log(result);
                    console.log(result.message_id + "mailtoken");
                    if (result.status == true) {
                        if (result.message_id == 'promo_not_submitted' || result.message_id == 'returning_user_different_promo') {
                            $('#email-entry').hide();
                            //setCookie('sweepstake_user_email', result.email, 1);
                            //let useremail = getCookie('sweepstake_user_email');
                            let useremail = result.email;
                            setTimeout(function () {
                                $('body .promo-form-sweepstake #email').val(useremail);
                            }, 2000);
                            $('body').find('.success-msg span').text(result.message);

                            //$('#popup-enabled-overlay').hide();
                            //$('.sweepstake-promo-entry__form').remove();
                            setTimeout(function () {
                                $('.sweepstake-section').fadeOut(400);
                                $('#email-entry').fadeOut(400);
                                $('#entry-form').fadeIn(400);
                                $('.promo-entry__subhead').fadeIn(400);
                                $('body').css('overflow-y', 'auto');
                                $('html, body').animate({
                                    scrollTop: $("#entry-form").offset().top - 200
                                }, 1000);

                            }, 2000);
                            setTimeout(function () {
                                $('.sweepstake-overlay').hide();
                            }, 5000);
                        } else if (result.message_id == 'returning_user_same_promo') {
                            if (evs_flag == 'true') {
                                /** UPDATE PROMOTION MASTER TABLE AFTER FORM SUBMIT ***/
                                var arrayObj = new Object();
                                arrayObj.email = result.email;
                                arrayObj.promo_identifier = prmo_id;
                                arrayObj.shop_url = shop_url;
                                var loaddata = JSON.parse(JSON.stringify(arrayObj));
                                $.ajax({
                                    type: 'POST',
                                    url: api_endpoint_url + '/api/update-user-promo',
                                    async: false,
                                    data: loaddata,
                                    dataType: 'json',
                                    headers: {
                                        "Authorization": 'Bearer ' + store_access_token,
                                        'Accept': 'application/json',
                                    },
                                    success: function (result) {
                                        //$('#sweapsteak-email__error-message').html("Calling DJA API. " + result.message).css('color', 'green');
                                        console.log(result);
                                    },
                                    error: function (e, t) {
                                        //alert(e.responseJSON);
                                        $('body').find('#sweapsteak-email__error-message').addClass("dsdsds");
                                        $('body').find('#sweapsteak-email__error-message').text(e.responseJSON.message);
                                    }
                                });
                            }
                            DJA_iwg(result.email);
                        } else {
                            $('body').find('#validation-legal').text(firsttimeEmailsubmit).fadeIn(100);
                        }

                    } else {
                        // $('body').find('#validation-legal').text(result.message);
                        if (result.message_id == "token_not_found") {
                            $('#popup-enabled-overlay').hide();
                            $('.spin-btn-overlay').css('pointer-events', 'auto');
                            $(".spin-btn-overlay").trigger("click");
                        }
                        if (result.message_id == "promo_already_submitted") {
                            $('#entry-form').hide();
                            // $('.cinco-spinwheel-section').hide();
                            // $("#cinco-results-othererrors").fadeIn(400);
                            // $('#popup-enabled-overlay').hide();
                            // $('.locator__wrap.product_locator').hide();
                            // $('#cinco-spot').hide();
                            //$('body').find('#cinco-results-othererrors .results').html(alreadyPlayedMain);
                            DJA_iwg(result.email);
                        }
                    }
                },
                error: function (e, t) {
                    $('body').find('.error-msg span').text(e.responseJSON.message);
                },
            });
        }
        // Onload Ajax call end
    }

    $("#sweepstake-submissionForm").validate({
        rules: {
            email: {
                required: true,
                emailValidate: true
            }
        },
        messages: {
            email: {
                required: emailRequiredMssg,
                emailValidate: invalidEmailMssg
            }
        },
        submitHandler: function () {
            var inputs = $("#sweepstake-submissionForm").serializeArray();
            var final_values = {};

            $.each(inputs, function (index, value) {
                final_values[value['name']] = value['value'];
            });

            var captcha_resp = grecaptcha.getResponse(0);
            if (captcha_resp != '' && captcha_resp != null) {
                final_values['g-recaptcha-response'] = captcha_resp;
                var data = JSON.stringify(final_values);

                if (evs_flag == 'true') {
                    // OnSubmit Ajax call start
                    $('body #sweepstake-submissionForm .button-submit').prop('disabled', true);
                    var email_id = $('#verification-email').val();

                    var apidata = { email: email_id, promo_identifier: prmo_id, shop_url: shop_url };
                    console.log(api_domain_url);
                    console.log(apidata);
                    var captcha_resp = grecaptcha.getResponse();
                    if (captcha_resp != '' && captcha_resp != null) {
                        DJAconnect_emailValidate(apidata, email_id, shop_token, api_domain_url, dja_api_url);
                    } else {
                        $('#sweepstake-captcha-custom-error').removeClass('hide');
                        $('body #sweepstake-submissionForm .button-submit').prop('disabled', false);
                    }
                    // OnSubmit Ajax call end
                } else {
                    //DJA Email Validation API
                    var email_id = $('#verification-email').val();
                    DJA_emailValidate(dja_api_url, email_id);
                }
            }
            else {
                $("#sweepstake-captcha-custom-error").removeClass("hide");
            }
            return false;
        }
    });

    //DJA Validation api
    function DJA_emailValidate(dja_api_url, email_id) {
        var api_url = dja_api_url + '/landing';
        var token = dja_api_token;
        var final_values = {};
        final_values['email'] = email_id;
        var data = JSON.stringify(final_values);
        console.log(data);
        var settings = {
            url: api_url,
            method: 'POST',
            headers: {
                Authorization: 'Bearer ' + token,
                'Content-Type': 'application/json',
            },
            dataType: 'json',
            data: data,
        };

        $.ajax(settings)
            .done(function (responseData) {
                var response = responseData;
                console.log(response);
                //setCookie('sweepstake_user_email', email_id, 1);
                email_validation_id = email_id;
                if (response.status == 'success') {
                    DJA_iwg(email_id);
                } else {
                    $('.sweepstake-promo-entry__field #verification-email').val('');
                    grecaptcha.reset();
                    $('body #sweepstake-submissionForm .button-submit').prop('disabled', false);

                    $('.sweepstake-overlay').show();
                    //let useremail = getCookie('sweepstake_user_email');
                    let useremail = email_validation_id;
                    $('body .promo-form-sweepstake #email').val(useremail);
                    setTimeout(function () {
                        $('.sweepstake-section').fadeOut(400);
                        $('#email-entry').fadeOut(400);
                        $('#entry-form').fadeIn(400);
                        $('html, body').animate({
                            scrollTop: $("#entry-form").offset().top - 200
                        }, 1000);
                        $('body').css('overflow-y', 'auto');
                    }, 2000);
                    setTimeout(function () {
                        //$('body').find('.success-msg span').text('');
                        $('.sweepstake-overlay').hide();
                    }, 5000);
                    ////////////////////////
                    // $('body').find('#validation-legal').text(usernotfound).fadeIn(100);
                    // $('body').find('#validation-legal').css('color', '#da1b7a');
                    // $('body #sweepstake-submissionForm .button-submit').prop('disabled', false);
                }
            })
            .fail(function (data) {
                const errors = data.responseJSON.errors;
                console.log(errors);
                $('body').find('#validation-legal').text(usernotfound).fadeIn(100);
                $('body').find('#validation-legal').css('color', '#da1b7a');
            });
    }


    //DJA Validation api
    function DJAconnect_emailValidate(validdata, email_id, shop_token, api_domain_url, dja_api_url) {

        var api_url = dja_api_url + '/landing';
        var token = dja_api_token;
        var final_values = {};
        final_values['email'] = email_id;
        var data = JSON.stringify(final_values);
        console.log(data);
        var settings = {
            url: api_url,
            method: 'POST',
            headers: {
                Authorization: 'Bearer ' + token,
                'Content-Type': 'application/json',
            },
            dataType: 'json',
            data: data,
        };

        $.ajax(settings)
            .done(function (responseData) {
                $('#sweepstake-captcha-custom-error').addClass('hide');
                $('body').find('.error-msg span').text();
                $('body').find('.success-msg span').text();
                var response = responseData;
                console.log(response);
                //setCookie('sweepstake_user_email', email_id, 1);
                email_validation_id = email_id;
                if (response.status == 'success') {

                    if (evs_flag == 'true') {
                        /** UPDATE PROMOTION MASTER TABLE AFTER FORM SUBMIT ***/
                        var arrayObj = new Object();
                        arrayObj.email = email_id;
                        arrayObj.promo_identifier = prmo_id;
                        arrayObj.shop_url = shop_url;
                        var loaddata = JSON.parse(JSON.stringify(arrayObj));
                        $.ajax({
                            type: 'POST',
                            url: api_endpoint_url + '/api/update-user-promo',
                            async: false,
                            data: loaddata,
                            dataType: 'json',
                            headers: {
                                "Authorization": 'Bearer ' + store_access_token,
                                'Accept': 'application/json',
                            },
                            success: function (result) {
                                //$('#sweapsteak-email__error-message').html("Calling DJA API. " + result.message).css('color', 'green');
                                console.log(result);
                            },
                            error: function (e, t) {
                                //alert(e.responseJSON);
                                $('body').find('#sweapsteak-email__error-message').addClass("dsdsds");
                                $('body').find('#sweapsteak-email__error-message').text(e.responseJSON.message);
                            }
                        });
                    }
                    DJA_iwg(email_id);

                } else {
                    $.ajax({
                        type: 'POST',
                        url: api_domain_url + '/api/check-email',
                        data: validdata,
                        dataType: 'json',
                        headers: { Authorization: 'Bearer ' + shop_token, Accept: 'application/json' },
                        success: function (result) {
                            //setCookie('sweepstake_user_email', email_id, 1);
                            email_validation_id = email_id;
                            if (result.status == true) {
                                $('.sweepstake-promo-entry__field #verification-email').val('');
                                grecaptcha.reset();
                                $('body #sweepstake-submissionForm .button-submit').prop('disabled', false);
                                // if (result.message_id == 'promo_not_submitted' || result.message_id == 'call_dja_api' || result.message_id == 'email_already_send') {
                                if (result.message_id == 'user_promo_saved') {
                                    $('body').find('#validation-legal').text(firsttimeEmailsubmit).fadeIn(100);
                                }
                                if (result.message_id == 'user_email_invalid_retry') {
                                    $('body').find('#validation-legal').text(usernotfound).fadeIn(100);
                                    $('body').find('#validation-legal').css('color', '#da1b7a');
                                }
                                if (result.message_id == 'promo_not_submitted' || result.message_id == 'returning_user_different_promo') {
                                    //$('body').find('.success-msg span').text(result.message);
                                    $('.sweepstake-overlay').show();
                                    //let useremail = getCookie('sweepstake_user_email');
                                    let useremail = email_validation_id;
                                    $('body .promo-form-sweepstake #email').val(useremail);
                                    setTimeout(function () {
                                        $('.sweepstake-section').fadeOut(400);
                                        $('#email-entry').fadeOut(400);
                                        $('#entry-form').fadeIn(400);
                                        $('html, body').animate({
                                            scrollTop: $("#entry-form").offset().top - 200
                                        }, 1000);
                                        $('body').css('overflow-y', 'auto');
                                    }, 1000);
                                    setTimeout(function () {
                                        $('body').find('.success-msg span').text('');
                                        $('.sweepstake-overlay').hide();
                                    }, 5000);
                                } else if (result.message_id == 'returning_user_same_promo') {
                                    if (evs_flag == 'true') {
                                        /** UPDATE PROMOTION MASTER TABLE AFTER FORM SUBMIT ***/
                                        var arrayObj = new Object();
                                        arrayObj.email = email_id;
                                        arrayObj.promo_identifier = prmo_id;
                                        arrayObj.shop_url = shop_url;
                                        var loaddata = JSON.parse(JSON.stringify(arrayObj));
                                        $.ajax({
                                            type: 'POST',
                                            url: api_endpoint_url + '/api/update-user-promo',
                                            async: false,
                                            data: loaddata,
                                            dataType: 'json',
                                            headers: {
                                                "Authorization": 'Bearer ' + store_access_token,
                                                'Accept': 'application/json',
                                            },
                                            success: function (result) {
                                                //$('#sweapsteak-email__error-message').html("Calling DJA API. " + result.message).css('color', 'green');
                                                console.log(result);
                                            },
                                            error: function (e, t) {
                                                //alert(e.responseJSON);
                                                $('body').find('#sweapsteak-email__error-message').addClass("dsdsds");
                                                $('body').find('#sweapsteak-email__error-message').text(e.responseJSON.message);
                                            }
                                        });
                                    }
                                    DJA_iwg(email_id);
                                } else if (result.message_id == "promo_already_submitted") {
                                    $('#entry-form').hide();
                                    $('#email-entry').fadeOut(400);
                                    $('.cinco-spinwheel-section').hide();
                                    $("#cinco-results-othererrors").fadeIn(400);
                                    $('#popup-enabled-overlay').hide();
                                    $('.locator__wrap.product_locator').hide();
                                    $('#cinco-spot').hide();
                                    $('body').find('#cinco-results-othererrors .results').html(alreadyPlayedMain);
                                } else {
                                    $('body').find('#validation-legal').text(firsttimeEmailsubmit).fadeIn(100);
                                    $('#email-entry .sweepstake-subheading').hide();
                                    $('#email-entry .sweepstake-promo-entry__form').hide();
                                }
                            } else {
                                if (result.message_id == 'user_email_invalid_retry') {
                                    $('body').find('#validation-legal').text(usernotfound).fadeIn(100);
                                    $('body').find('#validation-legal').css('color', '#da1b7a');
                                } else {
                                    $('body').find('#validation-legal').text(result.message).fadeIn(100).fadeOut(10000);
                                    $('body #sweepstake-submissionForm .button-submit').prop('disabled', false);
                                }
                            }
                        },
                        error: function (e, t) {
                            console.log(e);
                            $('body').find('#validation-legal').text(e.responseJSON.message).fadeIn(100);
                        },
                    });
                    $('#sweepstake-captcha-custom-error').addClass('hide');

                    ////////////////////////////////////////////////////////////
                    // $('body').find('#validation-legal').text(usernotfound).fadeIn(100);
                    // $('body').find('#validation-legal').css('color', '#da1b7a');
                    // $('body #sweepstake-submissionForm .button-submit').prop('disabled', false);
                }
            })
            .fail(function (data) {
                const errors = data.responseJSON.errors;
                console.log(errors);
                $('body').find('#validation-legal').text(usernotfound).fadeIn(100);
                $('body').find('#validation-legal').css('color', '#da1b7a');
            });
    }

});